import composedChart from "./../../../../components/composedChart/composedChart";
import {connect} from "react-redux";

export default connect(state => ({
  chartData: {
    metrics: state.studioInfo.barChart.metrics,
    data: state.studioInfo.barChart.data,
    colors: ["#4667d4", "#2651ac", "#95adf7"]
  }
}))(composedChart);
